import { keysLower } from "@/core/helpers";
import http from "@/api/services/http.service";

export const OPERATOR_ID_KEY = "operator";

const OperatorService = {
  operatorId() {
    return localStorage.getItem(OPERATOR_ID_KEY);
  },

  setOperatorId(id) {
    localStorage.setItem(OPERATOR_ID_KEY, id);
  },

  removeOperatorId() {
    localStorage.removeItem(OPERATOR_ID_KEY);
  },

  getOperatorSettings() {
    return this.get("/settings")
  },

  get(path, params) {
    return http.get("/operators/" + this.operatorId() + path, params).then((resp) => keysLower(resp.data));
  },

  post(path, params) {
    return http.post("/operators/" + this.operatorId() + path, params).then((resp) => keysLower(resp.data));
  },

  delete(path, params) {
    return http.delete("/operators/" + this.operatorId() + path, {data: params}).then((resp) => keysLower(resp.data));
  },

  put(path, params) {
    return http.put("/operators/" + this.operatorId() + path, params).then((resp) => keysLower(resp.data));
  },
};

export default OperatorService;
